const initialState = {
  tokens: [],
  checkIn: null,
  checkOut: null,
  totalNights: null,
  hotelCode: null,
  city: {
    id: null,
    label: null,
    country: null,
    name: null,
    countryOfResidence: 'AR',
  },
  citiesFiltered: [],
  roomInfo: {
    total_passengers: 2,
    totalRooms: 1,
  },
  quantity: null,
  search_option: {},
  searchId: null,
  passengers: [
    {
      id_passenger_type: 1,
      sequence: 1,
    },
    {
      id_passenger_type: 1,
      sequence: 1,
    },
  ],
  total_passengers: 2,
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SEARCH_DETAIL':
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default searchReducer;
